
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Modal from "./Modal";

import { ModalProps } from "./Modal.types";

const ModalContainer = ({
  withCloseIcon = false,
  open = false,
  centered = true,
  className,
  portalClassName,
  children,
  closeTimeoutMS = 300,
  testId,
  onClose = () => { },
}: ModalProps) => {
  let pathname: string | null = null;
  let hasLocation = false;
  
  try {
    const loc = useLocation();
    pathname = loc.pathname;
    hasLocation = true;
  } catch (e) {
    hasLocation = false;
  }

  useEffect(() => {
    return () => {
      document.body.style.removeProperty('--scrollbar-compensate');
      document.body.classList.remove('ReactModal__Body--open');
    };
  }, [hasLocation ? pathname : null]);

  const modalOpenCallback = () => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.setProperty('--scrollbar-compensate', `${scrollbarWidth}px`);
    setTimeout(() => {
      document.body.classList.add('ReactModal__Body--open');
    });
  }

  const modalCloseCallback = () => {
    document.body.style.removeProperty('--scrollbar-compensate');
    document.body.classList.remove('ReactModal__Body--open');
  }

  return (
    <Modal
      withCloseIcon={withCloseIcon}
      open={open}
      centered={centered}
      className={className}
      portalClassName={portalClassName}
      children={children}
      closeTimeoutMS={closeTimeoutMS}
      testId={testId}
      onClose={onClose}
      onAfterOpen={modalOpenCallback}
      onAfterClose={modalCloseCallback}
    />
  );
};

export default ModalContainer;
